<template>
  <div class="top_fixed">
    <pre-sale></pre-sale>
    <Meau></Meau>
  </div>
  <div class="home_cont">
    <router-view/>
  </div>
  <el-backtop :right="50" :bottom="100" />
</template>

<script>
  // @ is an alias to /src
  import { defineComponent, ref } from "vue";
  import PreSale from "@/components/PreSale.vue";
  import Meau from "@/components/Meau.vue";
  export default defineComponent({
    name: 'App',
    components: {
      PreSale,
      Meau
    }
  })
</script>

<style lang="scss">
#app {
  width: 100%;
  min-width: 600px;
  overflow: hidden;
  background: rgba(1, 1, 20, 1); 
  font-family: "Sharp Grotesk DB Cyr Book 20",Arial,sans-serif !important;
}
body, p, div, span, li {
  margin: 0;
}

.top_fixed {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 5;
}
.home_cont {
  width: 100%;
  margin-top: 120px;
  background: rgba(1, 1, 20, 1); 
}

</style>



<style>
.el-dialog {
  border-radius: 40px !important;
  padding: 0 !important;
  background: rgba(54, 63, 94, 1) !important;
}
.dialog-header {
  height: 75px;
  display: flex;
  color: #fff;
  padding: 0 20px;
  font-size: 20px;
  font-weight: 600;
  line-height: 27px;
  align-items: center;
  box-sizing: border-box;
  letter-spacing: 0.05em;
  justify-content: space-between;
  border-bottom: 1px solid rgba(217, 217, 217, 0.2);
}
.dialog-header .icon {
  cursor: pointer;
  width: 16px;
  height: 16px;
  background: url(./assets/close.png) no-repeat 100%/100%;
}
.dialog-content {
  width: 100%;
  color: #fff;
  padding: 0 40px;
  font-size: 14px;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
  box-sizing: border-box;
}

.dialog-method {
  display: flex;
  margin-top: 30px;
  align-items: center;
}
.dialog-method .input_label {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  line-height: 19px;
  margin-right: 15px;
  letter-spacing: 0em;
}
.dialog-input {
  display: flex;
  margin-top: 30px;
  align-items: center;
}
.dialog-input .input_label {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  line-height: 19px;
  margin-right: 15px;
  letter-spacing: 0em;
}

.dialog-input .input_title {
  color: rgb(3, 255, 145);
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  margin-right: 15px;
  letter-spacing: 0em;
}

.dialog-input .el-input .el-input__wrapper {
  border-radius: 58px;
  background: rgba(255, 255, 255, 0.8);
}
.dialog-input .el-input .el-input__wrapper .el-input__inner {
  color: rgba(51, 51, 51, 1);
}
.dialog-input .input_tips {
  flex: 1;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  margin-left: 15px;
  letter-spacing: 0em;
  color: rgba(255, 255, 255, 0.6);
}

.dialog-input .input_tips .tip_links {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  line-height: 19px;
  letter-spacing: 0em;
}
.dialog-input1 .el-input .el-input__wrapper {
  border-radius: 58px 0 0 58px;
}

.dialog-input1 .el-input .el-input-group__append {
  padding: 0;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0em;
  border-radius: 0 58px 58px 0;
  background: linear-gradient(271.98deg, #2AB36A 4.13%, #68CC4F 114.86%);
}
.dialog-input1 .el-input.active .el-input-group__append{
  color: #333;
  background: #999;
}
.dialog-input1 .el-input .el-input-group__append span {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  align-items: center;
  display: inline-flex;
  justify-content: center;
}

.dialog-footer {
  height: 93px;
  width: 100%;
  color: #fff;
  display: flex; 
  font-size: 14px;
  padding: 0 100px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0em;
  align-items: center;
  box-sizing: border-box;
  justify-content: space-around;
  border-top: 1px solid rgba(217, 217, 217, 0.2);
}
.dialog-footer .cancel {
  cursor: pointer;
  padding: 12px 80px;
  border-radius: 58px; 
  background: rgba(80, 88, 135, 1);
}
.dialog-footer .confirm {
  overflow: hidden;
  cursor: pointer;
  padding: 12px 80px;
  border-radius: 58px; 
  background: rgba(26, 152, 85, 1);
}

@media screen and (max-width: 1200px) {
  .dialog-content {
    padding: 0 20px;
  }
  .dialog-footer .cancel, .dialog-footer .confirm{
    padding: 10px 50px;
  }
}
</style>